// Core packages
import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material';

// Third party packages
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';

// Custom packages

// const italianRangeLabel = (page: number, pageSize: number, length: number) => {
//   if (length === 0 || pageSize === 0) { return `0 di ${length}`; }

//   length = Math.max(length, 0);

//   const startIndex = page * pageSize;

//   // If the start index exceeds the list length, do not try and fix the end index to the end.
//   const endIndex = startIndex < length ?
//     Math.min(startIndex + pageSize, length) :
//     startIndex + pageSize;

//   return `${startIndex + 1} - ${endIndex} di ${length}`;
// };


// export function getItalianPaginatorIntl() {
//   const paginatorIntl = new MatPaginatorIntl();

//   paginatorIntl.itemsPerPageLabel = 'Risultati per pagina:';
//   paginatorIntl.nextPageLabel = 'Pagina successiva';
//   paginatorIntl.previousPageLabel = 'Pagina precedente';
//   paginatorIntl.getRangeLabel = italianRangeLabel;

//   return paginatorIntl;
// }
@Injectable()
export class PaginatorIntlService extends MatPaginatorIntl {
  translate: TranslateService;
  itemsPerPageLabel = 'Risultati per pagina:';
  nextPageLabel = 'Pagina successiva';
  previousPageLabel = 'Pagina precedente';
  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 di ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} di ${length}`;
  };

  /**
   * Inject with translateService this class and
   * force re-translation of some data like labels
   *
   * @see https://stackoverflow.com/questions/46869616/how-to-use-matpaginatorintl
   *
   * @since 1.0.0
   */
  injectTranslateService(translate: TranslateService) {
    this.translate = translate;
    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });
    this.translateLabels();
  }

  /**
   * Translate paginator's string and push new translator
   * into the injected object
   *
   * @since 1.0.0
   */
  translateLabels(): void {
    forkJoin(
      this.translate.get('common.paginator.itemsPerPage'),
      this.translate.get('common.paginator.nextPage'),
      this.translate.get('common.paginator.prevPage'),
    )
      .pipe(
        take(1)
      )
      .subscribe(

        res => {
          this.itemsPerPageLabel = res[0];
          this.nextPageLabel = res[1];
          this.previousPageLabel = res[2];
        }
      );
  }
}
